import { render, staticRenderFns } from "./EditSiteChatResponseTemplate.vue?vue&type=template&id=71dd5763&scoped=true&"
import script from "./EditSiteChatResponseTemplate.vue?vue&type=script&lang=js&"
export * from "./EditSiteChatResponseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditSiteChatResponseTemplate.vue?vue&type=style&index=0&id=71dd5763&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd5763",
  null
  
)

export default component.exports